import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import LeadNotes from './LeadNotes';

/**
 * The lead notes panel reached from the Actions menu on the leads table.
 * The same panel appears as the Comments tab on the lead details page.
 */

interface LeadNotesModalProps {
  /** The lead whose notes to show; null keeps the modal closed. */
  leadId: string | null;
  /** Who the notes belong to, shown beside the title. */
  leadName?: string;
  onHide: () => void;
}

const LeadNotesModal: React.FC<LeadNotesModalProps> = ({ leadId, leadName, onHide }) => (
  <Modal show={!!leadId} onHide={onHide} centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title className="h5 mb-0">
          <i className="fa fa-sticky-note me-2 text-success"></i>
          Notes
          <span className="text-muted fw-normal ms-2" style={{ fontSize: '0.9rem' }}>
            {leadName || 'Lead'}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
      {leadId && <LeadNotes leadId={leadId} showHeading={false} />}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
    </Modal.Footer>
  </Modal>
);

export default LeadNotesModal;
